<div 
    id="cadastro-cliente-financeiro"
    class="tab-content p-24" 
    fusePerfectScrollbar fxLayout="column"
>
    <div
        fxLayout
        fxLayout.xs="column"
        fxLayoutWrap="wrap"
        fxLayoutAlign="space-between"
    >
        
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>Despesas Mensais</mat-label>
            <input 
                matInput 
                placeholder="Despesas Mensais" 
                [formControl]="despesas_mensais" 
                name="despesas_mensais"
                maxlength="255"
                currencyMask
                [options]="{  suffix: '', prefix: 'R$ ', thousands: '.', decimal: ',' }">
        </mat-form-field>
        
    </div>

    <div 
        fxLayout
        fxLayout.xs="column"
        fxLayoutWrap="wrap"
        fxLayoutAlign="space-between"
    >
        
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>Receita Mensal</mat-label>
            <input 
                matInput 
                placeholder="Receita Mensal" 
                [formControl]="receita_mensal" 
                name="receita_mensal"
                maxlength="255"
                currencyMask
                [options]="{  suffix: '', prefix: 'R$ ', thousands: '.', decimal: ',' }">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>Receita Familiar</mat-label>
            <input 
                matInput 
                placeholder="Receita Familiar" 
                [formControl]="receita_familiar" 
                name="receita_familiar" 
                maxlength="255"
                currencyMask
                [options]="{  suffix: '', prefix: 'R$ ', thousands: '.', decimal: ',' }">
        </mat-form-field>

    </div>

    <div 
        fxLayout
        fxLayout.xs="column"
        fxLayoutWrap="wrap"
        fxLayoutAlign="space-between"
    >
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="45">
            <mat-label>Situação Tributária</mat-label>
            <mat-select 
                placeholder="Situação Tributária"
                [(value)]="model.tipo_situacao_tributaria" 
                [formControl]="tipo_situacao_tributaria"                                            
                name="tipo_situacao_tributaria" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let situacao of listSituacaoTributaria" [value]="situacao.id">{{situacao.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerSituacao"></mat-spinner>
        </mat-form-field>

        <mat-form-field 
            appearance="outline" 
            floatLabel="always" 
            fxFlex="45"
        >
            <mat-label>Valor Internacional</mat-label>
            <input 
                matInput 
                placeholder="Valor Internacional" 
                [formControl]="valor_internacional" 
                name="valor_internacional" 
                maxlength="50"
                currencyMask
                [options]="{  suffix: '', prefix: 'R$ ', thousands: '.', decimal: ',' }">
        </mat-form-field>
    </div>

    <div class="actions" mat-dialog-actions>
        <button 
            class="accent"
            mat-button
            (click)="handleSave()"
            tabindex="-1">
            Salvar
        </button>
    </div>

</div>



